import { ChangeDetectorRef, Component, ViewChildren } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {  IonInfiniteScroll, NavController,  ActionSheetController } from '@ionic/angular';
import { ScrollHideConfig } from '../../../directives/scroll-hide';
import { CategoriesProvider, CategoryModel } from '../../../providers/categories/categories';
import { ConfigProvider } from '../../../providers/config/config';
import { LoaderProvider } from '../../../providers/loader/loader';
import { RanglistListModel, ResultListModel, ResultProvider, ResultSearchModel } from '../../../providers/result/result';
import { UserProvider } from '../../../providers/user/user';
import { SinleValueModel, ValueProvider } from '../../../providers/value/value';
import { MysportUserProfilePage } from '../../me/mysport/mysport-user-profile/mysport-user-profile';
import { SessionProvider } from '../../../providers/session/session';
import { EventComplex, EventDetailsModel, EventProvider, EventTievts, Pager } from '../../../providers/event/event';
/**
 * Generated class for the ResultSearchPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-result-teams',
  templateUrl: 'result-teams.html',
  styleUrls:['./result-teams.scss']
})
export class ResultTeamsPage {

  resultList = [];
  eventList = [];
  eventDates = [];
  activeEventName = "";
  activeDate = "";
  activeType: TYPE;

  teamPager;
  totalPager;
  showDistance: boolean = false;
  appLid;

  constructor(
    private resultService: ResultProvider,
    private valueService: ValueProvider,
    private configService: ConfigProvider,
    private loadingService: LoaderProvider,
    private eventService: EventProvider) { }

  ionViewDidEnter() {
    console.log('[results-teams.ts] did load...');
    this.initialize();
  }

  async initialize() {
    this.appLid = (await this.configService.config).client.lid;

    this.teamPager = {
      ena: null,
      stdt: null,
      limit: null,
      page: null,
      start: null
    };
    this.totalPager = {
      limit: null,
      page: null,
      start: null
    };

    this.updateSelections();
  }

  updateSelections() {
    let loader = this.loadingService.create({});
    loader.present();

    this.valueService.getClientEventNames(this.appLid).then((eventList) => {
      this.eventList = Object.assign([], eventList);
      this.activeEventName = this.eventList[0].value;

      this.updateEventDates();

      loader.dismiss();
    });
  }

  updateEventDates() {
    let loader = this.loadingService.create({});
    loader.present();

    this.valueService.getClientEventDates({ ena: this.activeEventName, cid: -1, lid: this.appLid }).then((eventDates) => {
      this.eventDates = Object.assign([], eventDates);
      this.activeDate = this.eventDates[0].value;

      loader.dismiss();
    });
  }

  async onTeamPressed(event?) {
    let loader = this.loadingService.create({});
    loader.present();

    this.teamPager.ena = this.activeEventName;
    this.teamPager.stdt = this.activeDate;
    this.showDistance = false;
    this.activeType = TYPE.TEAM;
    this.resultService.getTeamList(this.teamPager).then((resultList) => {
      console.log('resultList: ', resultList);
      this.resultList = Object.assign([], resultList);
      if (event) event.complete();
      loader.dismiss();
    });
  }

  onTotalPressed(event?) {
    let loader = this.loadingService.create({});
    loader.present();

    this.showDistance = true;
    this.activeType = TYPE.TOTAL;
    this.resultService.getTotalList(this.totalPager).then((resultList) => {
      console.log('resultList: ', resultList);
      this.resultList = Object.assign([], resultList);
      if (event) event.complete();
      loader.dismiss();
    });
  }

  loadNextPage(event) {
    this.activeType == TYPE.TEAM ? this.onTeamPressed(event) : this.onTotalPressed(event);
  }

  onEventNameChange() {
    this.updateEventDates();
  }
}
export enum TYPE {
  TEAM,
  TOTAL
}
